//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('categoryListMain', {
//        templateUrl: 'views/components/views/categoryListMain/categoryListMain.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['stateService', 'categoryListMainService', function (stateService, categoryListMainService) {
//            const vm = this;

//			vm.model = {
//                itemsListMainCategories: []
//			};

//            async function loadMainCategories() {
//                vm.model.itemsListMainCategories = await categoryListMainService.listMainCategories();
//            }
            
//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'categorylinkadd':
//                        go({ category_keyno_belongto: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };
            
//            vm.$onInit = function () {
//                loadMainCategories();
//            }
//		}]
//	});
//})();
